import { render, staticRenderFns } from "./PrivateUser.vue?vue&type=template&id=3d410b96"
import script from "./PrivateUser.vue?vue&type=script&lang=js"
export * from "./PrivateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports